import LearnRKBHome from "../../pages/learnrkb/LearnRkbHome"
import UserDashboardLayout from "../../components/layout/UserDashboardLayout"

export default function UserLearnRKBPage() {
  return (
    <UserDashboardLayout>
      <LearnRKBHome />
    </UserDashboardLayout>
  );
}
